export interface TimeSelector {
    view: HTMLElement;
}

export abstract class AbstractTimeSelector<E extends HTMLElement> implements TimeSelector {
    protected _onSelectCallback: (time: number) => void;

    public view!: E;

    constructor(times: number[], defaultTimeIndex: number, onSelect: (time: number) => void) {
        this.initView(times, defaultTimeIndex);
        this._onSelectCallback = onSelect;
    }

    protected abstract initView(times: number[], defaultTimeIndex: number): void;
}